export default function authConfig() {
    let token = localStorage.getItem('token').replace(/"/g, '');

    const config = {
        headers: { Authorization: `Bearer ${token}` }
      };

      return config;
}